import dutchMessages from "@/libs/localization/locales/nl.json";
import englishMessageData from "@/libs/localization/locales/en.json";

export const locales = ["nl", "en"] as const;
export type Locale = (typeof locales)[number];
export type Localized = { nl: string; en: string };
export const L = (nl: string, en: string): Localized => ({ nl, en });
export const isLocale = (value: string): value is Locale =>
  locales.includes(value as Locale);
const englishMessages: Record<keyof typeof dutchMessages, string> =
  englishMessageData;
export const messages = Object.fromEntries(
  Object.entries(dutchMessages).map(([key, nl]) => [
    key,
    { nl, en: englishMessages[key as keyof typeof dutchMessages] },
  ]),
) as { [Key in keyof typeof dutchMessages]: Localized };
export type MessageKey = keyof typeof messages;
export const formatMoney = (locale: Locale, cents: number) =>
  new Intl.NumberFormat(locale === "nl" ? "nl-NL" : "en-GB", {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);
export const formatDate = (
  locale: Locale,
  value: string,
  options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  },
) =>
  new Intl.DateTimeFormat(locale === "nl" ? "nl-NL" : "en-GB", {
    ...options,
    timeZone: "Europe/Amsterdam",
  }).format(new Date(`${value}T12:00:00Z`));
